import { Text, useMantineTheme } from '@mantine/core';

import { useParams } from 'react-router-dom';

import { type ResourceFilterState } from '../../types/miscTypes';
import useEnsisQuery from '../../hooks/useEnsisQuery';
import { ResourceList } from '..';

const VIEW_MODE_SELECTED_COPY = 'Resources are being used in this proposal';

interface Props {
  referenceUids: string[]
  allowResourceUpload: boolean
  onUpdateReferences?: (uids: string[]) => void
  defaultFilter?: ResourceFilterState
}
const SelectProposalResources: React.FC<Props> = (props: Props) => {
  const { referenceUids, allowResourceUpload, onUpdateReferences, defaultFilter } = props;
  const { colors } = useMantineTheme();
  const { organization } = useParams();
  const totalNumberOfResources = useEnsisQuery('/app/organization-resources', {
    queryParams: {
      organization_slug: organization ?? '',
      exclude_failed_resources: true
    }
  }).data?.total ?? 0;

  const onToggleReference = (resourceUid: string) => {
    if (onUpdateReferences !== undefined) {
      if (referenceUids.includes(resourceUid)) {
        onUpdateReferences(referenceUids.filter((ref) => ref !== resourceUid));
      } else {
        onUpdateReferences([...referenceUids, resourceUid]);
      }
    }
  };

  const title = (
    <Text c={colors.darkPurple[5]} fz='sm' fw='700'>
      {`${referenceUids.length}/${totalNumberOfResources} ${VIEW_MODE_SELECTED_COPY}`}
    </Text>
  );
  return (
    <ResourceList
      title={title}
      allowResourceUpload={allowResourceUpload}
      onSelectResource={onToggleReference}
      selectedResourceUids={referenceUids}
      defaultFilter={defaultFilter}
    />
  );
};

export default SelectProposalResources;
